export default {
  title: 'Descarcă aplicația {{app}}',
  qr_code_desc: 'Scanează acest cod QR cu telefonul pentru a descărca aplicația',
  cta: 'Descarcă aplicația și autentifică-te pentru a primi {{amount}} cashback!',
  download_from: 'Sau descarcă din:',
  direct_link: 'Link direct:',
};
